import { MissingConfig } from "../utils/beam-errors";
import { logger } from "../utils/logger";

export function enforceConfig<T>(keys: (keyof T)[], input: unknown): input is Required<T> {
  const missingKeys: string[] = [];
  const check = input as Record<string | number | symbol, unknown>;
  for (const key of keys) {
    if (check[key] == null) {
      missingKeys.push(key as string);
    }
  }
  if (missingKeys.length > 0) {
    logger.error("Beam Impact - Missing Required Config Values:\n", missingKeys.join(", "), input);
    throw new MissingConfig(missingKeys);
  }
  return true;
}

export function areRequiredKeysDefined<T extends object>(requiredKeys: (keyof T)[], config: T): boolean {
  return requiredKeys.every((key) => key in config && config[key] != null);
}
